module.exports = __webpack_public_path__ + "static/media/Boy.74695bef.svg";